import { ComponentType, forwardRef, PointerEventHandler, RefAttributes, TouchEventHandler } from 'react'
import { useAppSelector } from '~/store/hooks'
import { DoorTool } from './Doors/DoorTool'
import { DoorProductTool } from '~/components/DrawingCanvas/Doors/DoorProductTool'
import { DimensionLabelTool } from './DimensionLabels/Tool'
import { ProductTool } from '~/components/DrawingCanvas/Products/components/ProductTool'
import { ElevationPointTool } from './ElevationPoints/tool'
import { ElevationLineTool } from './ElevationLines/tool'
import { ComfortZoneCustomTool, ComfortZoneRectTool } from './ComfortZones/tool'
import { UtilityBoxTool } from './UtilityBoxes/tool'
import {
  ObstructionRectTool,
  ObstructionCircleTool,
  ObstructionCustomTool,
  ObstructionModelTool,
} from './Obstructions/tool'
import { WallEllipseTool, WallLineTool, WallRectTool } from './Walls/tool'
import { SelectTool } from '~/components/DrawingCanvas/SelectionTool'
import { Tools } from '~/config/tools'

type ReturnBoolean<T extends (...a: any) => any> = (...a: Parameters<T>) => boolean
export type ToolManagerRef = {
  onMouseMove: ReturnBoolean<PointerEventHandler<HTMLDivElement>>
  onMouseDown: ReturnBoolean<PointerEventHandler<HTMLDivElement>>
  onMouseUp: ReturnBoolean<PointerEventHandler<HTMLDivElement>>
  onTouchMove?: ReturnBoolean<TouchEventHandler<HTMLDivElement>>
  onTouchStart?: ReturnBoolean<TouchEventHandler<HTMLDivElement>>
  onTouchEnd?: ReturnBoolean<TouchEventHandler<HTMLDivElement>>
}

const toolMap = new Map<
  Tools,
  ComponentType<{ activeTool: string; activeToolProps: any } & RefAttributes<ToolManagerRef>>
>([
  ['DOOR_TOOL', DoorTool],
  ['DOOR_PRODUCT_TOOL', DoorProductTool],
  ['DIMENSION_TOOL', DimensionLabelTool],
  ['PRODUCT_TOOL', ProductTool],
  ['ELEVATION_POINT_TOOL', ElevationPointTool],
  ['ELEVATION_LINE_TOOL', ElevationLineTool],
  ['COMFORT_ZONE_LINE_TOOL', ComfortZoneCustomTool],
  ['COMFORT_ZONE_TOOL', ComfortZoneRectTool],
  ['UTILITY_BOX_TOOL', UtilityBoxTool],
  ['OBSTRUCTION_POLYGON_TOOL', ObstructionCustomTool],
  ['OBSTRUCTION_BOX_TOOL', ObstructionRectTool],
  ['OBSTRUCTION_CIRCLE_TOOL', ObstructionCircleTool],
  ['OBSTRUCTION_TOOL', ObstructionModelTool],
  ['LINE_TOOL', WallLineTool],
  ['RECTANGLE_TOOL', WallRectTool],
  ['ELLIPSE_TOOL', WallEllipseTool],
  ['SELECT_TOOL', SelectTool],
])

export const ToolManager = forwardRef<ToolManagerRef>(function ToolManager(_props, ref) {
  const activeTool = useAppSelector(it => it.tools.activeTool)
  const activeToolProps = useAppSelector(it => it.tools.activeToolProps)

  const Component = toolMap.get(activeTool) ?? SelectTool
  if (Component === undefined) {
    return <></>
  }
  return <Component activeTool={activeTool} activeToolProps={activeToolProps} ref={ref} />
})
